import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class AplicativoProvider {
  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) {}

  informacoesAplicativo() {
    return this.http.post<any>(this.baseUrl + '/aplicativo/informacoes-aplicativo', {}).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  atualizarCadastro() {
    return this.http.post<any>(this.baseUrl + '/aplicativo/atualizar-cadastro', {}).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/aplicativo/aplicativo.ts